import { render, staticRenderFns } from "./widget-icon.vue?vue&type=template&id=4c1fd664&scoped=true"
import script from "./widget-icon.vue?vue&type=script&lang=js"
export * from "./widget-icon.vue?vue&type=script&lang=js"
import style0 from "./widget-icon.vue?vue&type=style&index=0&id=4c1fd664&prod&lang=less&scoped=true"
import style1 from "./widget-icon.vue?vue&type=style&index=1&id=4c1fd664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fd664",
  null
  
)

export default component.exports